import {
  AdGroupToCreateType,
  CAMPAIGN_STEPS,
  CampaignBasicDetailsType,
  CampaignTemplate,
  CookieSet,
  CustomDomainList,
  FoundCompaniesInfo,
  FoundEmailsInfo,
  FoundHubspotPage,
  PublicDomainList,
  PublicDomainListData,
  RoleTitleGroup,
} from "../../../types/campaignTypes";

const CAMPAIGN_CREATOR_PREFIX = "campaignToCreate/";

export const SET_IS_PENDING = `${CAMPAIGN_CREATOR_PREFIX}SET_IS_PENDING`;
type SET_IS_PENDING = typeof SET_IS_PENDING;

export const SET_RESET_CAMPAIGN_TO_CREATE = `${CAMPAIGN_CREATOR_PREFIX}SET_RESET_CAMPAIGN_TO_CREATE`;
type SET_RESET_CAMPAIGN_TO_CREATE = typeof SET_RESET_CAMPAIGN_TO_CREATE;

export const SET_CAMPAIGN_TO_CREATE_BASIC_DETAILS = `${CAMPAIGN_CREATOR_PREFIX}SET_CAMPAIGN_TO_CREATE_BASIC_DETAILS`;
type SET_CAMPAIGN_TO_CREATE_BASIC_DETAILS = typeof SET_CAMPAIGN_TO_CREATE_BASIC_DETAILS;

export const SET_CAMPAIGN_TO_CREATE_SELECTED_ADVERTISER = `${CAMPAIGN_CREATOR_PREFIX}SET_CAMPAIGN_TO_CREATE_SELECTED_ADVERTISER`;
type SET_CAMPAIGN_TO_CREATE_SELECTED_ADVERTISER = typeof SET_CAMPAIGN_TO_CREATE_SELECTED_ADVERTISER;

export const SET_ADGROUP_TEMPLATES = `${CAMPAIGN_CREATOR_PREFIX}SET_ADGROUP_TEMPLATES`;
type SET_ADGROUP_TEMPLATES = typeof SET_ADGROUP_TEMPLATES;

export const SET_ROLE_TITLE_LIST = `${CAMPAIGN_CREATOR_PREFIX}SET_ROLE_TITLE_LIST`;
type SET_ROLE_TITLE_LIST = typeof SET_ROLE_TITLE_LIST;

export const SET_CAMPAIGN_ROLE_TITLE_COOKIES = `${CAMPAIGN_CREATOR_PREFIX}SET_CAMPAIGN_ROLE_TITLE_COOKIES`;
type SET_CAMPAIGN_ROLE_TITLE_COOKIES = typeof SET_CAMPAIGN_ROLE_TITLE_COOKIES;

export const SET_COMPANY_SORT_VALUES = `${CAMPAIGN_CREATOR_PREFIX}SET_COMPANY_SORT_VALUES`;
type SET_COMPANY_SORT_VALUES = typeof SET_COMPANY_SORT_VALUES;

export const SET_HUBSPOT_LISTS = `${CAMPAIGN_CREATOR_PREFIX}SET_HUBSPOT_LISTS`;
type SET_HUBSPOT_LISTS = typeof SET_HUBSPOT_LISTS;

export const SET_FOUND_COMPANY_INFO = `${CAMPAIGN_CREATOR_PREFIX}SET_FOUND_COMPANY_INFO`;
type SET_FOUND_COMPANY_INFO = typeof SET_FOUND_COMPANY_INFO;

export const SET_FOUND_EMAILS_INFO = `${CAMPAIGN_CREATOR_PREFIX}SET_FOUND_EMAILS_INFO`;
type SET_FOUND_EMAILS_INFO = typeof SET_FOUND_EMAILS_INFO;

export const SET_FROM_FILE = `${CAMPAIGN_CREATOR_PREFIX}SET_FROM_FILE`;
type SET_FROM_FILE = typeof SET_FROM_FILE;

export const SET_FOUND_HUBSPOT_PAGES = `${CAMPAIGN_CREATOR_PREFIX}SET_FOUND_HUBSPOT_PAGES`;
type SET_FOUND_HUBSPOT_PAGES = typeof SET_FOUND_HUBSPOT_PAGES;

export const SET_CAMPAIGN_LANDING_PAGE = `${CAMPAIGN_CREATOR_PREFIX}SET_CAMPAIGN_LANDING_PAGE`;
type SET_CAMPAIGN_LANDING_PAGE = typeof SET_CAMPAIGN_LANDING_PAGE;

export const SET_ADGROUP_TO_CREATE = `${CAMPAIGN_CREATOR_PREFIX}SET_ADGROUP_TO_CREATE`;
type SET_ADGROUP_TO_CREATE = typeof SET_ADGROUP_TO_CREATE;

export const SET_GEO_TARGET_OPTIONS = `${CAMPAIGN_CREATOR_PREFIX}SET_GEO_TARGET_OPTIONS`;
type SET_GEO_TARGET_OPTIONS = typeof SET_GEO_TARGET_OPTIONS;

export const SET_SELECTED_GEO_TARGET_OPTIONS = `${CAMPAIGN_CREATOR_PREFIX}SET_SELECTED_GEO_TARGET_OPTIONS`;
type SET_SELECTED_GEO_TARGET_OPTIONS = typeof SET_SELECTED_GEO_TARGET_OPTIONS;

export const SET_SELECTED_ZIP_CODES = `${CAMPAIGN_CREATOR_PREFIX}SET_SELECTED_ZIP_CODES`;
type SET_SELECTED_ZIP_CODES = typeof SET_SELECTED_ZIP_CODES;

export const SET_SELECTED_SEGMENT_IDS = `${CAMPAIGN_CREATOR_PREFIX}SET_SELECTED_SEGMENT_IDS`;
type SET_SELECTED_SEGMENT_IDS = typeof SET_SELECTED_SEGMENT_IDS;

export const SET_PUBLIC_DOMAIN_LISTS = `${CAMPAIGN_CREATOR_PREFIX}SET_PUBLIC_DOMAIN_LISTS`;
type SET_PUBLIC_DOMAIN_LISTS = typeof SET_PUBLIC_DOMAIN_LISTS;

export const SET_CUSTOM_DOMAIN_LISTS = `${CAMPAIGN_CREATOR_PREFIX}SET_CUSTOM_DOMAIN_LISTS`;
type SET_CUSTOM_DOMAIN_LISTS = typeof SET_CUSTOM_DOMAIN_LISTS;

export const SET_SELECTED_DOMAIN_LISTS_IDS = `${CAMPAIGN_CREATOR_PREFIX}SET_SELECTED_DOMAIN_LISTS_IDS`;
type SET_SELECTED_DOMAIN_LISTS_IDS = typeof SET_SELECTED_DOMAIN_LISTS_IDS;

export const SET_SELECTED_DOMAIN_LISTS = `${CAMPAIGN_CREATOR_PREFIX}SET_SELECTED_DOMAIN_LISTS`;
type SET_SELECTED_DOMAIN_LISTS = typeof SET_SELECTED_DOMAIN_LISTS;

export const SET_CREATED_CUSTOM_DOMAIN_LIST = `${CAMPAIGN_CREATOR_PREFIX}SET_CREATED_CUSTOM_DOMAIN_LIST`;
type SET_CREATED_CUSTOM_DOMAIN_LIST = typeof SET_CREATED_CUSTOM_DOMAIN_LIST;

export const SET_UPDATED_CUSTOM_DOMAIN_LISTS = `${CAMPAIGN_CREATOR_PREFIX}SET_UPDATED_CUSTOM_DOMAIN_LISTS`;
type SET_UPDATED_CUSTOM_DOMAIN_LISTS = typeof SET_UPDATED_CUSTOM_DOMAIN_LISTS;

export const SET_USE_ADGROUP_TEMPLATE = `${CAMPAIGN_CREATOR_PREFIX}SET_USE_ADGROUP_TEMPLATE`;
type SET_USE_ADGROUP_TEMPLATE = typeof SET_USE_ADGROUP_TEMPLATE;

export const SET_SELECTED_ADGROUP_TEMPLATE = `${CAMPAIGN_CREATOR_PREFIX}SET_SELECTED_ADGROUP_TEMPLATE`;
type SET_SELECTED_ADGROUP_TEMPLATE = typeof SET_SELECTED_ADGROUP_TEMPLATE;

export const SET_SELECTED_ADGROUPS = `${CAMPAIGN_CREATOR_PREFIX}SET_SELECTED_ADGROUPS`;
type SET_SELECTED_ADGROUPS = typeof SET_SELECTED_ADGROUPS;

export const SET_SEGMENTS_INCLUDE = `${CAMPAIGN_CREATOR_PREFIX}SET_SEGMENTS_INCLUDE`;
type SET_SEGMENTS_INCLUDE = typeof SET_SEGMENTS_INCLUDE;

export const SET_CAMPAIGN_STEPS = `${CAMPAIGN_CREATOR_PREFIX}SET_CAMPAIGN_STEPS`;
type SET_CAMPAIGN_STEPS = typeof SET_CAMPAIGN_STEPS;

export const SET_CAMPAIGN_TEMPLATE_NAME = `${CAMPAIGN_CREATOR_PREFIX}SET_CAMPAIGN_TEMPLATE_NAME`;
type SET_CAMPAIGN_TEMPLATE_NAME = typeof SET_CAMPAIGN_TEMPLATE_NAME;

export const SET_CAMPAIGN_TEMPLATE = `${CAMPAIGN_CREATOR_PREFIX}SET_CAMPAIGN_TEMPLATE`;
type SET_CAMPAIGN_TEMPLATE = typeof SET_CAMPAIGN_TEMPLATE;

export type SetIsPending = {
  type: SET_IS_PENDING;
  payload: boolean;
};

export type SetResetCampaignToCreate = {
  type: SET_RESET_CAMPAIGN_TO_CREATE;
};

export type SetCampaignBasicDetails = {
  type: SET_CAMPAIGN_TO_CREATE_BASIC_DETAILS;
  payload: Partial<CampaignBasicDetailsType>;
};

export type SetCampaignCookies = {
  type: SET_CAMPAIGN_ROLE_TITLE_COOKIES;
  payload: Record<string, CookieSet[]> | null;
};

export type SetRoleTitleList = {
  type: SET_ROLE_TITLE_LIST;
  payload: RoleTitleGroup[];
};

export type SetCompanySortValues = {
  type: SET_COMPANY_SORT_VALUES;
  payload: any;
};

export type SetHubSpotLists = {
  type: SET_HUBSPOT_LISTS;
  payload: any;
};

export type SetFoundCompanyInfo = {
  type: SET_FOUND_COMPANY_INFO;
  payload: FoundCompaniesInfo | null;
};

export type SetEmailsToHash = {
  type: SET_FOUND_EMAILS_INFO;
  payload: FoundEmailsInfo | null;
};

export type SetFoundHubspotPages = {
  type: SET_FOUND_HUBSPOT_PAGES;
  payload: FoundHubspotPage[];
};

export type SetCampaignLandingPage = {
  type: SET_CAMPAIGN_LANDING_PAGE;
  payload: string;
};

export type SetAdGroupToCreate = {
  type: SET_ADGROUP_TO_CREATE;
  payload: AdGroupToCreateType;
};

export type SetUseAdGroupTemplate = {
  type: SET_USE_ADGROUP_TEMPLATE;
  payload: boolean;
};

export type SetSelectedAdGroupTemplate = {
  type: SET_SELECTED_ADGROUP_TEMPLATE;
  payload: string | null;
};

export type SetGeoTargetOptions = {
  type: SET_GEO_TARGET_OPTIONS;
  payload: Array<any>;
};

export type SetSelectedGeoTargetOptions = {
  type: SET_SELECTED_GEO_TARGET_OPTIONS;
  payload: Array<string>;
};

export type SetSelectedZipCodes = {
  type: SET_SELECTED_ZIP_CODES;
  payload: Array<string>;
};

export type SetSelectedSegmentIds = {
  type: SET_SELECTED_SEGMENT_IDS;
  payload: Array<string>;
};

export type SetPublicDomainLists = {
  type: SET_PUBLIC_DOMAIN_LISTS;
  payload: PublicDomainList[];
};

export type SetCustomDomainLists = {
  type: SET_CUSTOM_DOMAIN_LISTS;
  payload: CustomDomainList[];
};

export type SetCreatedCustomDomainList = {
  type: SET_CREATED_CUSTOM_DOMAIN_LIST;
  payload: CustomDomainList;
};

export type SetUpdatedCustomDomainLists = {
  type: SET_UPDATED_CUSTOM_DOMAIN_LISTS;
  payload: CustomDomainList[];
};

export type SetSelectedDomainListsIds = {
  type: SET_SELECTED_DOMAIN_LISTS_IDS;
  payload: Array<number>;
};

export type SetSelectedDomainLists = {
  type: SET_SELECTED_DOMAIN_LISTS;
  payload: Array<PublicDomainListData>;
};

export type SetSegmentsInclude = {
  type: SET_SEGMENTS_INCLUDE;
  payload: {
    domain: string;
    include: boolean;
  };
};

export type SetCampaignSteps = {
  type: SET_CAMPAIGN_STEPS;
  payload: CAMPAIGN_STEPS[] | null;
};

export type SetCampaignTemplateName = {
  type: SET_CAMPAIGN_TEMPLATE_NAME;
  payload: string | null;
};

export type SetCampaignTemplate = {
  type: SET_CAMPAIGN_TEMPLATE;
  payload: CampaignTemplate | null;
};
